import { gql } from "@apollo/client";

export const trapAlarmsQuery = gql`
    query TrapAlarmsAdmin($page: Int, $sort: SortInput, $query: String) {
        trapAlarmsAdmin(page: $page, sort: $sort, query: $query) {
            nodes {
                id
                name
                phone
                pin
                user {
                    id
                    firstname
                    lastname
                }
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
